import { createContext, useState, useEffect, useContext } from 'react';
import api from '../services/api';
import { AuthContext } from './AuthContext';

export const ShiftContext = createContext();

export const ShiftProvider = ({ children }) => {
  const [activeSession, setActiveSession] = useState(null);
  const [loading, setLoading] = useState(true);
  const { user } = useContext(AuthContext);

  const checkActiveSession = async () => {
    if (!user) return;
    try {
      const res = await api.get('/shifts/active');
      setActiveSession(res.data);
    } catch (err) {
      console.error('Failed to check active session:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (user) {
      checkActiveSession();
    } else {
      setActiveSession(null);
      setLoading(false);
    }
  }, [user]);

  const openSession = async (openingCash) => {
    try {
      const res = await api.post('/shifts/open', { openingCash });
      setActiveSession(res.data);
      return res.data;
    } catch (err) {
      throw err.response?.data?.error || 'Failed to open session';
    }
  };

  const closeSession = async (actualCash, notes) => {
    try {
      const res = await api.post('/shifts/close', { actualCash, notes });
      setActiveSession(null);
      return res.data;
    } catch (err) {
      throw err.response?.data?.error || 'Failed to close session';
    }
  };

  return (
    <ShiftContext.Provider value={{ 
      activeSession, 
      loading, 
      openSession, 
      closeSession, 
      refreshSession: checkActiveSession 
    }}>
      {children}
    </ShiftContext.Provider>
  );
};
